import { ContactFormSearch } from "components/Contacts/contactFormSearch";
import DatePickerRange from "components/PeriodSelection/DatePickerRange";
import TableDatePicker from "components/PeriodSelection/DatePickerRange";
import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import SearchCurrency from "../searchCurrency";
import { CommonUtilities } from "commonUtils";
import TransactionServices from "../TransactionServices";
import { Filter } from "filter";

export default function EditInvoiceBox(param: any) {
    console.log(param);

    let [headerType, setHeaderType] = useState("");
    let [refError, setrefError] = useState(false);
    let [fieldsInvalid, setfieldsInvalid] = useState(false);
    let [saveAlertInvoice, setsaveAlertInvoice] = useState(false);
    let [invalidHomeValue, setinvalidHomeValue] = useState(false);
    let [invalidExchRate1, setinvalidExchRate1] = useState(false);
    let [selectInvoice, setSelectInvoice] = useState<any>([]);

    useEffect(() => {
        if (param?.showtab == 1) { headerType = "Publishing Song" }
        if (param?.showtab == 2) { headerType = "Publishing Writer" }
        if (param?.showtab == 3) { headerType = "Digital" }
        if (param?.showtab == 4) { headerType = "Physical" }
        if (param?.showtab == 5) { headerType = "Costs" }
        if (param?.showtab == 6) { headerType = "Advances" }
        if (param?.showtab == 7) { headerType = "Licensing" }
        if (param?.showtab == 8) { headerType = "Adjustments" }

        setHeaderType(headerType)

        if (param?.invoiceSelect?.invoiceNum) {
            selectInvoice = param?.invoiceSelect;
            setSelectInvoice(selectInvoice)
        } else {
            setSelectInvoice({
                ...selectInvoice, currencySign: "USD", homeSign: "USD", headerType: headerType?.toLocaleLowerCase(), inverseRate: 1, exchRate1: 1, invId: 0, hasData: "", royaltyPeriod: 20251231, setRelease: 0
            });
        }
    }, [param])

    const onClose = () => { param.EditInvoiceClose(); }

    let [dialogueAddOpenView, setdialogueAddOpenView] = useState(false);
    let [selectKontact, setSelectKontact] = useState<any>([]);
    const onChangeContact = (e: any) => {
        console.log(e)
        selectKontact = e;
        setSelectKontact(selectKontact)
        setSelectInvoice({ ...selectInvoice, accountCode: e?.kontactCode })
    }

    const dateSelection = (e: any) => {
        console.log(e)

        setSelectInvoice({ ...selectInvoice, invoiceDate: Filter?.DateTimeFormatNumberSeparate(e) })
        console.log(Filter?.DateTimeFormatNumberSeparate(e))
    }

    let [currencyType, setCurrencyType] = useState("");
    let [currency, setCurrency] = useState(false);
    const Closecurrency = (e: any) => {
        currency = false
        setCurrency(currency)

        setSelectInvoice({ ...selectInvoice, [currencyType]: e?.territoryCurrency })

        console.log(e)
    }

    const invoiceSave = () => {

        if (validateField()) {
            console.log("Invalid")

            TransactionServices?.getTransactionRef({ transactionRef: selectInvoice?.transactionRef, invId: selectInvoice?.invId ?? 0 }).then((respond: any) => {
                if (respond) {
                    TransactionServices.invoice_save(selectInvoice).then((respond: any) => {
                        selectInvoice = respond;
                        setSelectInvoice(selectInvoice)
                    })
                }
            })
        }
    }

    const validateField = () => {
        var validateField_sts = true;

        const homeSign_field: any = document.getElementById("homeSign");
        const homeValue_field: any = document.getElementById("homeValue");
        const exchRate1_field: any = document.getElementById("exchRate1");
        const accountCode_field: any = document.getElementById("accountCode");
        const invoiceDate_field: any = document.getElementById("invoiceDate");
        const currencySign_field: any = document.getElementById("currencySign");
        const royaltyPeriod_field: any = document.getElementById("royaltyPeriod");
        const currencyValue_field: any = document.getElementById("currencyValue");
        const transactionRef_field: any = document.getElementById("transactionRef");

        if (!selectInvoice?.homeSign) { homeSign_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.homeValue) { homeValue_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.exchRate1) { exchRate1_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.invoiceDate) { invoiceDate_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.accountCode) { accountCode_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.currencySign) { currencySign_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.currencyValue) { currencyValue_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.royaltyPeriod) { royaltyPeriod_field.style.border = "1px solid #e50e0e"; }
        if (!selectInvoice?.transactionRef) { transactionRef_field.style.border = "1px solid #e50e0e"; }

        if (!validateField_sts) {
            CommonUtilities.showToastDawer('There was a problem submitting your request, one or more fields are missing or incorrect', 'fail')
        }

        setTimeout(() => {
            homeSign_field.style.border = "1px solid 1px solid #dedede";
            exchRate1_field.style.border = "1px solid 1px solid #dedede";
            homeValue_field.style.border = "1px solid 1px solid #dedede";
            invoiceDate_field.style.border = "1px solid 1px solid #dedede";
            accountCode_field.style.border = "1px solid 1px solid #dedede";
            currencySign_field.style.border = "1px solid 1px solid #dedede";
            royaltyPeriod_field.style.border = "1px solid 1px solid #dedede";
            currencyValue_field.style.border = "1px solid 1px solid #dedede";
            transactionRef_field.style.border = "1px solid 1px solid #dedede";
        }, 2000);

        return validateField_sts
    }

    const calculateInverseValue = (numericValue: any) => {
        console.log(numericValue)
        console.log(selectInvoice?.inverseRate)
        console.log(selectInvoice?.exchRate1)

        var inverse_Rate = selectInvoice?.inverseRate ?? 1
        var currency_Value = selectInvoice?.currencyValue ?? 1

        if (Number(numericValue) != 0) {
            inverse_Rate = inverse_Rate / Number(numericValue)
            currency_Value = currency_Value * Number(numericValue)
        }

        if (inverse_Rate == Infinity) {
            inverse_Rate = 0
        }

        setSelectInvoice({ ...selectInvoice, exchRate1: Number(numericValue), inverseRate: inverse_Rate, currencyValue: currency_Value })
    }

    const calculateCurrentValueFromExcRate = (numericValue: any, type: any) => {

        if (type == "LV") {
            setSelectInvoice({ ...selectInvoice, homeValue: numericValue, currencyValue: numericValue * selectInvoice?.exchRate1 })
        }

        if (type == "RCV") {
            setSelectInvoice({ ...selectInvoice, homeValue: numericValue / selectInvoice?.exchRate1, currencyValue: numericValue })
        }
    }

    const invoiceClear = () => {
        if (param?.invoiceSelect?.invoiceNum) {
            selectInvoice = param?.invoiceSelect;
            setSelectInvoice(selectInvoice)
        } else {

            selectInvoice = {};
            setSelectInvoice(selectInvoice)
            setSelectInvoice({
                ...selectInvoice, currencySign: "USD", homeSign: "USD", headerType: headerType?.toLocaleLowerCase(), inverseRate: 1, exchRate1: 1, invId: 0, hasData: "", royaltyPeriod: 20251231, setRelease: 0
            });
        }
    }

    return (
        <div className="ws-10">
            <Modal open={param.param} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-10 paddingCenterBox bgTransparent' }} >
                <div className="ws-12 box landing">
                    <div className="box-header-main">
                        <h2>{headerType} Invoice Entry </h2>
                    </div>

                    <div className="pm  ws-12">
                        {saveAlertInvoice && <div className="alert alert-info">Invoice Data for has been saved successfully</div>}

                        {fieldsInvalid && <div className="alert alert-danger ">There was a problem submitting your request, one or more fields are missing or incorrect.</div>}

                        {refError && <div className="alert alert-danger" >Transaction reference <i >test warner</i> is already taken </div>}

                        <div className="ws-12">
                            <div className="w-50 content-card pull-left">
                                <div className="form-format">
                                    <label className="text-bold ws-12">Account*</label>
                                    <div className="label-entries">
                                        <div className="ws-10">
                                            <input type="text" className=" text-uppercase ws-12" name="kontactDisplay" placeholder="Browse an Account" id="accountCode" onChange={(e: any) => setSelectInvoice({ ...selectInvoice, accountCode: e.target.value })} value={selectInvoice?.accountCode ?? ""} required readOnly disabled />

                                        </div>
                                        <ContactFormSearch onChange={onChangeContact} data={""} open={dialogueAddOpenView} />
                                        <button type="button" className="icon-btn primary pull-right hide" title="Select Contact"><i className="icon-user-add"></i></button>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="text-bold ws-12">Transaction Ref*</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter Transaction Reference" className="text-uppercase" id="transactionRef" value={selectInvoice?.transactionRef ?? ""} onChange={(e: any) => setSelectInvoice({ ...selectInvoice, transactionRef: e.target.value })} name="transactionRef" title="This is your reference to enable the transaction to be retraced in auditing." required />
                                    </div>
                                </div>

                                {selectInvoice?.invoiceNum && <div className="form-format" data-ng-hide="!invoice.invId">
                                    <label className="text-bold ws-12">Internal Ref (auto allocated)</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter Invoice Num" className="text-uppercase" value={selectInvoice?.invoiceNum ?? ""} onChange={(e: any) => setSelectInvoice({ ...selectInvoice, invoiceNum: e.target.value })} name="invoiceNum" readOnly />
                                    </div>
                                </div>}

                                <div >
                                    <div className="form-format">
                                        <label className="text-bold ws-12">Description</label>
                                        <div className="label-entries">
                                            <input type="text" placeholder="Description" ng-change="calculateCurrentValueFromExcRate(invoice)" value={selectInvoice?.invDescription ?? ""} onChange={(e: any) => setSelectInvoice({ ...selectInvoice, invDescription: e.target.value })} name="description" title="Enter a brief description of the transaction e.g “Advance on Signature”" />
                                        </div>
                                    </div>
                                </div>

                                <div >
                                    <div className="form-format">
                                        <label className="text-bold ws-12">Comments</label>
                                        <div className="label-entries">
                                            <textarea placeholder="Comments" value={selectInvoice?.comments ?? ""} onChange={(e: any) => setSelectInvoice({ ...selectInvoice, comments: e.target.value })} name="comments" title="Notes for your information(This text is included on the invoice list export but will not be shown on the royalty statement)" className=" ng - valid - maxlength"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-50 content-card pull-right">

                                <div className="ws-12">

                                    <div className="form-format">
                                        <div className="ws-6">
                                            <label className="text-bold ws-12">Invoice Date*</label>

                                            <div className="label-entries hide">
                                                <input type="text" placeholder="Invoice Date" readOnly onChange={(e: any) => setSelectInvoice({ ...selectInvoice, invoiceDate: e.target.value })} id="invoiceDate" title="This is the date of the invoice / transaction" required />
                                            </div>

                                            <DatePickerRange onChange={dateSelection} name={""} type={"single"} data={selectInvoice?.invoiceDate ?? ""} id="invoiceDate" />
                                        </div>
                                    </div>
                                </div>
                                <div className="ws-12">
                                    <div className="form-format">
                                        <div className="ws-6">
                                            <label className="text-bold ws-12">Week Number</label>

                                            <div className="label-entries">
                                                <input type="number" placeholder="Week Number" className="text-right " value={selectInvoice?.weekNumber ?? ""} onChange={(e: any) => setSelectInvoice({ ...selectInvoice, weekNumber: e.target.value })} name="weekNumber" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ws-12">

                                    <div className="form-format">
                                        <div className="ws-6">
                                            <label className="text-bold ws-12">Royalty Period*</label>

                                            <div className="label-entries">
                                                <select className=" text-right" name="royaltyPeriod" value={selectInvoice?.royaltyPeriod ?? ""} id="royaltyPeriod" onChange={(e: any) => setSelectInvoice({ ...selectInvoice, royaltyPeriod: e.target.value })} >
                                                    <option value="">Choose a Period</option>
                                                    <option value="20251231" label="Apr 1, 2019 - Jun 30, 2019">Apr 1, 2019 - Jun 30, 2019</option>
                                                    <option value="20251231" label="Jul 1, 2019 - Sep 30, 2019">Jul 1, 2019 - Sep 30, 2019</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-6">

                                    <div className="form-format">
                                        <label className="text-bold ws-12">Local Value*</label>

                                        <div className="label-entries">
                                            <input type="number" placeholder="Local Value" className="numberAlign text-right" id="homeValue" value={selectInvoice?.homeValue ?? ""} onChange={(e: any) => calculateCurrentValueFromExcRate(e.target.value, "LV")} name="homeValue" required />
                                            {invalidHomeValue && <div className="alert alert-danger"> Home must be numeric</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="text-bold ws-12">Inverse Rate</label>

                                        <div className="label-entries">
                                            <input type="number" placeholder="Inverse Rate" ng-init="calculateInverseValue(invoice)" value={selectInvoice?.inverseRate ?? 1} min="0" name="inverseRate" readOnly required />
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="text-bold ws-12">My Currency*</label>

                                        <div className="label-entries">
                                            <input type="text" placeholder="Home Curr" value={selectInvoice?.homeSign ?? ""} id="homeSign" onClick={() => { setCurrency(true); setCurrencyType("homeSign") }} name="homeSign" data-ng-click="territoryOpener('HomeCurrency')" readOnly required />
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-6">
                                    <div className="form-format">
                                        <label className="text-bold ws-12">Reported Currency Value*</label>

                                        <div className="label-entries">
                                            <input type="number" placeholder="Reported Currency Value" className="numberAlign text-right" id="currencyValue" onChange={(e: any) => calculateCurrentValueFromExcRate(e.target.value, "RCV")} value={selectInvoice?.currencyValue ?? ""} name="currencyValue" required />

                                        </div>
                                    </div>
                                </div>

                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="text-bold ws-12">Exch Rate*</label>

                                        <div className="label-entries">
                                            <input type="number" placeholder="Exch Rate" value={selectInvoice?.exchRate1 ?? 1} onChange={(e: any) => calculateInverseValue(e.target.value)} name="exchRate1" id="exchRate1" required />
                                            {invalidExchRate1 && <div className="alert alert-danger">Exchange Rate must be numeric</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="text-bold ws-12">Currency Code*</label>

                                        <div className="label-entries">
                                            <input type="text" placeholder="Reported Currency" value={selectInvoice?.currencySign ?? ""} onClick={() => { setCurrency(true); setCurrencyType("currencySign") }} name="currencySign" id="currencySign" readOnly required />
                                        </div>
                                    </div>

                                </div>

                            </div >
                        </div >

                        <div className="ws-12 content-card mt">
                            <button className="btn icon-btn edit btn-s pull-right height40 width120" onClick={invoiceSave}><i className="icon-save"></i> Save  </button>
                            {selectInvoice?.invoiceNum && <a className="icon-btn primary btn-s pull-right height40" ng-click="openDetailsPop(frminvoice, efrminvoice)" data-ng-show="invId">
                                <i className="icon-ok icon-list icon-white"></i> Load File/Transactions
                            </a>}
                            <button className="icon-btn delete btn-s pull-right height40 width120" onClick={invoiceClear}><i className="icon-reload"></i> Reset</button>
                            <button className="icon-btn delete btn-s pull-right height40 width120" onClick={onClose}><i className="icon-close"></i> Close </button>
                        </div>

                    </div >


                    {
                        (() => {
                            if (currency) {
                                return (<SearchCurrency Closecurrency={Closecurrency} open={currency} />)
                            }

                        })()
                    }

                </div >
            </Modal >
        </div >
    )
}